import getAngularModule from 'App/babel/angularHelpers/getAngularModule';
import Label from 'App/resources/Model/Label';
import {
	campaignsTracker,
	formsTracker,
	mailCampaignTracker,
	mailTemplateTracker,
	segmentsTracker
} from 'App/babel/helpers/Tracker';
import SegmentResource from 'App/resources/Segment';
import MultiActionsResource from 'Resources/MultiActions';
import type Segment from 'App/resources/Model/Segment';

// Segments are not Elasticsearch-indexed, so they can't ride the ES-backed
// multi-action framework like Forms/Templates/Campaigns. Resolve the selected
// segments via SQL and apply the label per-row (segment volumes are low).
// Segments are multi-label: "add label" appends the chosen label to each
// segment's existing labels; "remove label" (no id) clears all labels.
const updateSegmentLabels = (selectedLabel: Label, filters: object) => {
	return SegmentResource.find({ ...filters, limit: 9999 }).then(res =>
		Promise.all(
			res.data.map((segment: Segment) => {
				let labels: { id: number }[];
				if (selectedLabel.id) {
					const existing = (segment.labels || []).map((label: Label) => ({ id: label.id as number }));
					labels = existing.some((label: { id: number }) => label.id === selectedLabel.id)
						? existing
						: [...existing, { id: selectedLabel.id }];
				} else {
					labels = [];
				}
				return SegmentResource.save({ id: segment.id, labels }, { skipNotification: true });
			})
		)
	);
};

const updateLabels = (entity: string, selectedLabel: Label, filters: object, selected: number) => {
	const properties = [{ name: 'Labels', value: selectedLabel.id ? [selectedLabel.id] : [] }];
	const MultiActions = getAngularModule('MultiActions');
	const AppService = getAngularModule('AppService');
	const customerId = AppService.getCustomerId();
	switch (entity) {
		case 'Form':
			formsTracker.track(formsTracker.events.ADDED_LABEL);
			return MultiActions.customer(customerId).updateForm(selected, properties, filters);
		case 'MailTemplate':
			mailTemplateTracker.track(mailTemplateTracker.events.ADDED_LABEL);
			return MultiActions.customer(customerId).updateMailtemplate(selected, properties, filters);
		case 'MailCampaign':
			mailCampaignTracker.track(mailCampaignTracker.events.ADDED_LABEL);
			return MultiActions.customer(customerId).updateMailCampaign(selected, properties, filters);
		case 'Segment':
			segmentsTracker.track(segmentsTracker.events.ADDED_LABEL);
			return updateSegmentLabels(selectedLabel, filters);
		case 'Project':
			campaignsTracker.track(campaignsTracker.events.ADDED_LABEL);
			return MultiActionsResource.customer(customerId).updateProject(selected, properties, filters);
	}
	return new Promise(() => {});
};

export default updateLabels;
